import React, { useState } from "react";
import { Popover, Space, Avatar, message, Col, Row } from "antd";
import {
  DownOutlined,
  SafetyOutlined,
  UserOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";
import "./scss/index.scss";
import { EditableInput, InformationDrawer } from "../index";
import { useNavigate } from "react-router-dom";
import { authActions } from "../../store/actions";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { Btn } from "../forms";
import { Spinner } from "../spinner";
// import * as yup from "yup";
export const PopoverComponent = () => {
  let dispatch = useDispatch();
  const [openDrawer, setOpenDrawer] = useState(false);
  let navigate = useNavigate();
  let auth = JSON.parse(localStorage.getItem("auth"));
  const signout = () => {
    localStorage.removeItem("auth");
    dispatch(authActions.signout());
    navigate("/");
  };
  let [load, setLoad] = useState(false);
  const [submit, setSubmit] = useState(false);
  console.log(submit);
  // const personalInfoValidationSchema = yup.object({
  //   fullname: yup
  //     .string("* Enter your Full name")
  //     .max(50, "* Full Name can be at most 50 characters long"),
  // .required("* Full Name is required"),
  // email: yup
  //   .string("* Enter your email")
  //   .max(40, "* Email can be at most 40 characters long")
  //   .email("* Enter a valid email")
  //   .trim("* There should not be a single space"),
  // .required("* Email is required"),
  // });

  const onSubmitFunction = (values, { resetForm }) => {
    setLoad(true);
    console.log(values);
    let letterNumber = /^[0-9]+$/;
    let regexEmail = /^\w+([./-]?\w+)*@\w+([./-]?\w+)*(\.\w{2,3})+$/;

    if (JSON.stringify(values) === "{}") {
      message.error("you have not updated any field !");
      setLoad(false);
    } else if (values?.telephone?.length < 17) {
      message.error("Telephone Number Must Be Greater Than 17 Digits");
      setLoad(false);
    } else if (values?.telephone?.length > 17) {
      message.error("Telephone Number Must Be Smaller Than 17 Digits");
      setLoad(false);
    } else if (
      values?.telephone?.length === 17 &&
      !values?.telephone?.match(letterNumber)
    ) {
      message.error("Telephone Number Must Be Digits Only");
      setLoad(false);
    } else if (values?.email?.length > 5 && !values?.email?.match(regexEmail)) {
      message.error("Enter a valid email");
      setLoad(false);
    } else {
      let id = auth.user._id;
      dispatch(authActions.personalInfoUpdate(values, id, setLoad));

      resetForm();
    }
  };
  const formik = useFormik({
    // validationSchema: personalInfoValidationSchema,
    initialValues: {},
    onSubmit: onSubmitFunction,
  });

  const menu = (
    <>
      <div className="w-full p-2">
        <div className="drop-down-content pb-1 pl-5 pr-5 ">
          <p className="drop-down-content-title text-center ">My Information</p>
          <hr className="drop-down-hr"></hr>
          <div className="avatar-email-div flex justify-start items-center">
            <Avatar size="large" />
            <div className="avatar-email-div-content p-3">
              <p className="avatar-email-div-title">
                {auth?.user?.first_name} {auth?.user?.last_name}
              </p>
              <p className="avatar-email-div-email">{auth?.user.type.type}</p>
            </div>
          </div>
          <hr className="drop-down-hr"></hr>
          <p
            className="user-information-items flex items-center py-2"
            onClick={() => setOpenDrawer(true)}
          >
            <span className="user-information-icons">
              <UserOutlined className="profile-icon" />
            </span>
            <span className="pl-1">My Profile</span>
          </p>
          <p className="user-information-items flex items-center py-2">
            <span className="user-information-icons">
              <SafetyOutlined className="profile-icon" />
            </span>
            <span className="pl-1">Help</span>
          </p>
          <hr className="drop-down-hr"></hr>
          <p className="user-information-items flex items-center py-2 pl-0.5">
            <span className="user-information-icons">
              <LogoutOutlined className="popover-icon" />
            </span>
            <span className="pl-1" onClick={() => signout()}>
              Log out
            </span>
          </p>
        </div>
      </div>
    </>
  );
  let getRole = JSON.parse(`${localStorage.getItem("auth")}`);
  let role = getRole?.user.type.type;
  return (
    <div>
      <InformationDrawer
        openDrawer={openDrawer}
        setOpenDrawer={setOpenDrawer}
        content={
          <div className="pl-3 pr-3">
            <h2 className="title">Personal information</h2>
            <form onSubmit={formik.handleSubmit}>
              {role === "Medical Profession" ? (
                <Row className="mt-5" justify="space-between">
                  {" "}
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex align-center">
                      <label className="pr-5 font-semibold">First Name :</label>
                      <EditableInput
                        text={auth?.user?.first_name}
                        name="first_name"
                        onChange={formik.handleChange}
                      />
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex align-center">
                      <label className="pr-5 font-semibold">Last Name :</label>
                      <EditableInput
                        text={auth?.user?.last_name}
                        name="last_name"
                        onChange={formik.handleChange}
                      />
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex flex-col align-center">
                      <label className="pr-5 font-semibold">
                        Date Of Birth :
                      </label>
                      <EditableInput
                        text={auth?.user?.date_of_birth}
                        name="date_of_birth"
                        onChange={formik.handleChange}
                      />
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex flex-col align-center">
                      <label className="pr-5 font-semibold">Email :</label>
                      <EditableInput
                        text={auth?.user?.email}
                        name="email"
                        onChange={formik.handleChange}
                      />{" "}
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex flex-col align-center">
                      <label className="pr-5 font-semibold">Phone# :</label>
                      <EditableInput
                        text={auth?.user?.telephone}
                        name="telephone"
                        onChange={formik.handleChange}
                        id="telephone"
                        {...formik.getFieldProps("telephone")}
                      />
                      {/* {submit && formik.errors.telephone && (
                        <span className="error">{formik.errors.telephone}</span>
                      )} */}
                      {formik.errors.telephone && formik.touched.telephone ? (
                        <div
                          style={{ border: "2px solid red", width: "180px" }}
                        >
                          {" "}
                          <span className="error">
                            {formik.errors.telephone}
                          </span>
                        </div>
                      ) : null}
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex flex-col align-center">
                      <label className="pr-5 font-semibold">Manager Id</label>
                      <span>{auth?.user?.mid}</span>
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex flex-col align-center">
                      <label className="pr-5 font-semibold">Location Id</label>
                      <span>{auth?.user?.employee_location}</span>
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex flex-col align-center">
                      <label className="pr-5 font-semibold">Address :</label>
                      <EditableInput
                        text={auth?.user?.address}
                        name="address"
                        onChange={formik.handleChange}
                      />
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex flex-col align-center">
                      <label className="pr-5 font-semibold">City :</label>
                      <EditableInput
                        text={auth?.user?.city}
                        name="city"
                        onChange={formik.handleChange}
                      />
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex flex-col align-center">
                      <label className="pr-5 font-semibold">State</label>
                      <EditableInput
                        text={auth?.user?.state}
                        name="state"
                        onChange={formik.handleChange}
                      />
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex flex-col align-center">
                      <label className="pr-5 font-semibold">Zip Code</label>
                      <EditableInput
                        text={auth?.user?.zip_code}
                        name="zip_code"
                        onChange={formik.handleChange}
                      />
                    </div>
                  </Col>
                </Row>
              ) : role === "Manager" ? (
                <Row className="mt-5" justify="space-between">
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex align-center">
                      <label className="pr-5 font-semibold">Full Name :</label>
                      <EditableInput
                        name="full_name"
                        onChange={formik.handleChange}
                        text={auth?.user?.full_name}
                        cursorPointer="cursor-pointer"
                      />
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex align-center">
                      <label className="pr-5 font-semibold">MID:</label>
                      <p className="user-information-modal-title">
                        {auth?.user?.mid}
                      </p>
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex align-center">
                      <label className="pr-5 font-semibold">Telephone :</label>
                      <EditableInput
                        text={auth?.user?.telephone}
                        name="telephone"
                        onChange={formik.handleChange}
                      />
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex align-center">
                      <label className="pr-5 font-semibold">Email :</label>
                      <EditableInput
                        text={auth?.user?.email}
                        cursorPointer="cursor-pointer"
                        name="email"
                        onChange={formik.handleChange}
                      />
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={24} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex align-center">
                      <label className="pr-5 font-semibold">
                        Lab Address :
                      </label>
                      <EditableInput
                        text={auth?.user?.lab_address}
                        cursorPointer="cursor-pointer"
                        name="lab_address"
                        onChange={formik.handleChange}
                      />
                    </div>
                  </Col>
                </Row>
              ) : role === "Asins" ? (
                <Row className="mt-5" justify="space-between">
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex align-center">
                      <label className="pr-5 font-semibold">Full Name</label>
                      <EditableInput
                        text={auth?.user?.full_name}
                        cursorPointer="cursor-pointer"
                        name="full_name"
                        onChange={formik.handleChange}
                      />
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex align-center">
                      <label className="pr-5 font-semibold">email</label>
                      <EditableInput
                        text={auth?.user?.email}
                        cursorPointer="cursor-pointer"
                        name="email"
                        onChange={formik.handleChange}
                      />
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={24} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex align-center">
                      <label className="pr-5 font-semibold">Telephone :</label>
                      <EditableInput
                        text={auth?.user?.telephone}
                        cursorPointer="cursor-pointer"
                        name="telephone"
                        onChange={formik.handleChange}
                      />
                    </div>
                  </Col>
                </Row>
              ) : (
                <Row className="mt-5" justify="space-between">
                  {" "}
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex align-center">
                      <label className="pr-5 font-semibold">First Name :</label>
                      <EditableInput
                        text={auth?.user?.first_name}
                        cursorPointer="cursor-pointer"
                        name="first_name"
                        onChange={formik.handleChange}
                      />
                    </div>
                  </Col>
                  <Col sm={24} md={24} xs={24} lg={11} className="mx-1 mt-5">
                    <div className="user-information-modal-title flex align-center">
                      <label className="pr-5 font-semibold">Last Name :</label>
                      <EditableInput
                        text={auth?.user?.last_name}
                        cursorPointer="cursor-pointer"
                        name="last_name"
                        onChange={formik.handleChange}
                      />
                    </div>
                  </Col>
                </Row>
              )}

              <Row>
                <Col xs={24} sm={10} md={8} lg={6} className="w-1/4 mt-10">
                  <div>
                    <Btn
                      value={
                        load ? (
                          <span>
                            <Spinner className="btn-spinner mr-2" /> Loading...
                          </span>
                        ) : (
                          "Submit"
                        )
                      }
                      bgColor="#008ba4"
                      color="white"
                      border="1px solid #c3c3c7"
                      btnClass="btnDarkHover"
                      type="submit"
                      onClick={() => setSubmit(true)}
                    ></Btn>
                  </div>
                </Col>
              </Row>
            </form>
          </div>
        }
      />
      <Popover placement="bottomRight" content={menu} trigger="click">
        <div
          className="ant-dropdown-link flex items-center cursor-pointer"
          onClick={(e) => e.preventDefault()}
        >
          <Space size="small">
            <Avatar
              className="navbar-avatar"
              src={
                <img
                  src="https://joeschmoe.io/api/v1/random"
                  style={{ width: 32 }}
                />
              }
            />
            <DownOutlined size="large" />
          </Space>
        </div>
      </Popover>
    </div>
  );
};

PopoverComponent.propTypes = {
  children: PropTypes.element,
};
